export class InvitationTrustPilot {
}
